module.exports = __webpack_public_path__ + "static/media/detailed-planning.6bd189f9.svg";